(function () {
    "use strict";

    angular.module("virtualFairs")
        .controller("PhysicalFairSettingsFormController", PhysicalFairSettingsFormController);
    
    PhysicalFairSettingsFormController.$inject = [
        "ExpoService", 
        "CountriesNewService",
        "expo", 
        "expoTypes", 
        "aliases", 
        "serviceRegions",
        "costCenters",
        "currencies",
        "eventGroups",
        "profileTypes",
        "cities",
        "toastr", 
        "$state",
        "sellers"
    ];
    
    function PhysicalFairSettingsFormController(
        ExpoService, 
        CountriesNewService,
        expo, 
        expoTypes, 
        aliases, 
        serviceRegions,
        costCenters,
        currencies,
        eventGroups,
        profileTypes,
        cities,
        toastr,
        $state,
        sellers) {
        
        var vm = this;

        vm.getTitle = getTitle;
        vm.mountExpo = mountExpo;
        vm.savePhysicalFairSettings = savePhysicalFairSettings;
        vm.goToList = goToList;
        vm.logisticsToPdf = logisticsToPdf;
        vm.changeNetworkingEvent = changeNetworkingEvent;
        vm.selectExposAddresses = selectExposAddresses;
        vm.addCity = addCity;
        vm.removeCity = removeCity;
        vm.addEventDate = addEventDate;
        vm.removeEventDate = removeEventDate;
        vm.title = "Create Physical Event"
        vm.logoPreview = '';
        vm.flag = true;
        vm.sellers = sellers;
        vm.selectAll = selectAll;
        vm.removeAll = removeAll;
        vm.selectTerritories = selectTerritories;
        vm.selectedTerritories = [];
        vm.getCountries = getCountries;
        vm.selectedCountries = [];
        vm.selectCountries = selectCountries;
        vm.setExhibitorsCountry = setExhibitorsCountry;

        // news
        vm.expoCityId = null;

        vm.logicOptions = [
            {id: 0, name: 'No'},
            {id: 1, name: 'Yes'}
        ];

        vm.dateOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: false,
            locale: {
              format: "DD/MM/YYYY",
              cancelLabel: "Close"
            },
        };

        vm.dateTimeOptions = {
            autoUpdateInput: true,
            autoApply: true,
            singleDatePicker: true,
            showTimepicker: true,
            locale: {
              format: "DD/MM/YYYY HH:MM",
              cancelLabel: "Close"
            },
        };

        vm.eventsColors = [
            { colors: '{"background":"#FFD200","text":"#000000"}', name: 'TSW' },
            { colors: '{"background":"#E62431","text":"#FFFFFF"}', name: 'EduCanada / Study in Canada' },            
            { colors: '{"background":"#0A79C5","text":"#FFD200"}', name: 'Study in Sweden' },
            { colors: '{"background":"#c2350e","text":"#f5ce3a"}', name: 'Study in Spain' },
            { colors: '{"background":"#000091","text":"#FFFFFF"}', name: 'Study in France' },
            { colors: '{"background":"#0059b7","text":"#FFFFFF"}', name: 'Study in Europe' },
        ];

        async function getTitle () {
            if(vm.expo) {
                vm.title = "Edit Physical Event"
            }
            return await vm.title;
        }

        async function mountExpo() {
            let defaultColor = vm.eventsColors.find(function(item) {
                return item.name === 'TSW';
            });

            let defaultCountry = vm.exhibitorsCountries.find(function(item) {
                return item.name === 'Worldwide';
            });

            let defaultCurrency = vm.currencies.find(function(item) {
                return item.code === 'USD';
            });

            let defaultNo = vm.logicOptions.find(function(item) {
                return item.id === 0;
            });

            vm.expo = {

                // Basic Information 
                id: null,
                name: "",
                expo_type_id: "",
                alias: "",
                event_group_id: "",
                profile_types: [],
                description: "",
                logistics_url: "",
                logistics_pdf: "",
                image: "",
                currency: defaultCurrency.code,
                target_exhibitors: "Wordwide",

                // Deadline
                registration_deadline: "",
                booth_setup_deadline: "",
                standard_rate_date: "",

                // Regions
                expos_services_regions: [],

                // Cities
                locations: [], // tratar como esse array é montado

                // ICS file
                description_event_ics: "",
                description_booth_setup_ics: "",
                sessions: [],
                offer_assistance: defaultNo.id,
                assistante_rate: 0,
                expos_staff: [],

                // Calendar
                students_countries: [],
                event_colors: defaultColor,
                exhibitors_country: defaultCountry,                

            };
            if(expo) {
                vm.expo.id = expo.id;
                vm.expo.name = expo.name;
                vm.expo.title = expo.title;
                vm.expo.name_for_students = expo.name_for_students;
                vm.expo.expo_type_id = expo.expo_type_id;
                vm.expo.alias = expo.alias;
                vm.expo.currency = expo.currency;
                vm.expo.event_group_id = expo.event_group_id;
                vm.expo.offer_assistants = expo.offer_assistants;
                vm.expo.assistante_rate = expo.assistante_rate;
                expo.profile_types.filter(function(item) {
                    vm.expo.profile_types.push(item.id);
                });
                vm.expo.description = expo.description;
                vm.expo.target_exhibitors = expo.target_exhibitors;
                vm.expo.logistics_url = expo.logistics_url;
                vm.expo.registration_deadline = expo.registration_deadline;
                vm.expo.booth_setup_deadline = expo.booth_setup_deadline;
                vm.expo.early_bird_datetime_utc = expo.locations[0].booths[0].standard_rate_date;
                vm.expo.meeting_recording_url = expo.meeting_recording_url ? expo.meeting_recording_url : "";                
                vm.expo.description_event_ics = expo.description_event_ics ? expo.description_event_ics : "";
                vm.expo.description_booth_setup_ics = expo.description_booth_setup_ics ? expo.description_booth_setup_ics : "";
                expo.regions.filter(function(item) {
                    vm.expo.expos_services_regions.push(item.id);
                });
                expo.locations.filter(async function(item) {
                    await vm.addCity(item);
                });

                // expo.expos_staff = [];
                expo.staff.filter(function(item) {
                    vm.expo.expos_staff.push(parseInt(item.adm_user_id));
                });

                if (expo.students_countries != null) {
                    let selectedIds = expo.students_countries.split(",").map(id => id.trim());

                    vm.selectedCountries = vm.countries.filter(country =>
                      selectedIds.includes(country.id)
                    );

                    if (vm.selectedCountries) {
                        let usedTerritoryIds = [...new Set(vm.selectedCountries.map(c => c.territory_id))];

                        vm.selectedTerritories = vm.territories.filter(t =>
                          usedTerritoryIds.includes(t.id)
                        );
                    }
                }

                if (expo.event_colors != null) {
                    debugger;
                    let color = vm.eventsColors.find(function(item) {
                        return expo.event_colors == item.colors;
                    });
                    if (!color) {
                        color = {
                            colors: expo.event_colors,
                            name: expo.alias
                        };
                        vm.eventsColors.push(color);
                    }
                    vm.expo.event_colors = color;
                }
                if (expo.exhibitors_country != null) {
                    let country = vm.exhibitorsCountries.find(function(item) {
                        return expo.exhibitors_country == item.iso;
                    });
                    vm.expo.exhibitors_country = country;
                }

            } else {
                vm.addCity();
            }
        }

        async function savePhysicalFairSettings () {
            vm.flag = false;
            let fields = {};
            angular.copy(vm.expo, fields);

            // deadlines

            fields.logistics_pdf = vm.expo.logistics_pdf;            

            fields.booth_setup_deadline = moment(vm.expo.booth_setup_deadline).format('YYYY-MM-DD 23:59:59');
            fields.early_bird_datetime_utc = moment(vm.expo.early_bird_datetime_utc).format('YYYY-MM-DD 23:59:59');
            fields.registration_deadline = moment(vm.expo.registration_deadline).format('YYYY-MM-DD 23:59:59');

            // profile types
            fields.profile_types = JSON.stringify(fields.profile_types);

            // service regions
            fields.expos_services_regions = JSON.stringify(fields.expos_services_regions);

            // service regions
            fields.expos_staff = JSON.stringify(fields.expos_staff);

            // locations
            $.each(fields.locations, function(key, location) {
                delete location.tmp;
                $.each(location.expos_dates, function(key, date) {
                    date.date = moment(date.date).format('YYYY-MM-DD');
                    date.start_time = moment(date.start_time).format('HH:mm');
                    date.end_time = moment(date.end_time).format('HH:mm');
                });

                if (vm.expo['image_'+location.expo_city_id]) {
                    fields['image_'+location.expo_city_id] = vm.expo['image_'+location.expo_city_id];
                }
            });   

            fields.locations = JSON.stringify(fields.locations);

            fields.event_colors = JSON.stringify(vm.expo.event_colors.colors);
            if (vm.selectedCountries) {
                fields.students_countries = vm.selectedCountries
                    .map(c => c.id)
                    .join(', ');
            }
            if (vm.expo.exhibitors_country) {
                fields.exhibitors_country = vm.expo.exhibitors_country.iso;
            }


            ExpoService.savePhysicalFairSettings(fields).then(function(response) {
                vm.flag = true;
                if(expo) {
                    toastr.success('Physical Event successfully updated!');
                    vm.goToList();
                } else {
                    toastr.success('Physical Event successfully created!');
                    vm.goToList();
                }
            })
        }

        async function goToList () {
            return await $state.go('root.physicalfairs.settings');
        }

        async function logisticsToPdf () {
        }

        async function changeNetworkingEvent () {
            if(vm.expo.has_networking_event == 0) {
                vm.expo.scheduling_deadline = "";
            }
        }

        async function selectExposAddresses (location) {

            if (!location.expo_city_id) {
                return false;
            }
            let query = {};
            query['expo_city_id'] = location.expo_city_id;
            return ExpoService.getExpoAddresses(query).then(function(response){
                if (typeof location.tmp === 'undefined') {
                    location.tmp = {};
                }
                location.tmp.expo_addresses = response.data;
                location.expo_address_id = response.data.id;
                return response.data;
            });
        }

        async function addCity (location = null) {

            var new_location = {};

            if(location) {
                new_location.id = location.id;
                new_location.tmp = {};
                new_location.cost_center_id = location.cost_center_id;
                new_location.is_high_school_road_show = location.is_high_school_road_show;
                new_location.booths_quantity = parseInt(location.booths_quantity);
                new_location.expo_city_id = location.address.expo_city_id;
                new_location.canceled = location.canceled;
                new_location.image_url = location.image_url;
                new_location.whatsapp_community_url = location.whatsapp_community_url;
                new_location.image = location.image;

                location.expo_city_id = location.address.expo_city_id;
                await vm.selectExposAddresses(location);
                new_location.tmp.expo_addresses = location.tmp.expo_addresses;
                new_location.standard_rate = location.booths[0].standard_rate;
                new_location.late_rate = location.booths[0].late_rate;
                new_location.expos_dates = [];

                location.dates.filter(function(item) {
                    new_location.expos_dates.push({ 
                        id: item.id,
                        date: item.date, 
                        start_time: new Date(moment(item.date + ' ' + item.start_time, 'YYYY-MM-DD HH:mm:ss')),
                        end_time: new Date(moment(item.date + ' ' + item.end_time, 'YYYY-MM-DD HH:mm:ss')),

                    });
                });

                new_location.expo_address_id = location.address.id;

             
            } else {

                new_location.id = null;
                new_location.expos_booths = { standard_rate: "", late_rate: "" };
                new_location.expos_dates = [{ 
                    date: "", 
                    start_time: "",
                    end_time: "",
                    start_datetime_utc: "",
                    end_datetime_utc: "" 
                }];
                new_location.cost_center_id = "";
                new_location.is_high_school_road_show = "";
                new_location.booths_quantity = "";
                new_location.expo_address_id = "";
                new_location.canceled = 0;
                new_location.image_url = "";
                new_location.whatsapp_community_url = "";
                new_location.image = "";
            }
            await vm.expo.locations.push(new_location);
        }

        async function removeCity (location) {

            vm.expo.locations.splice(vm.expo.locations.indexOf(location), 1)
            if(vm.expo.locations.length <= 1) {
                return false;
            }
            // vm.expo.locations.splice(index, 1);
        }
        
        async function addEventDate (location) {
            location.expos_dates.push({ 
                id: null,
                date: "", 
                start_time: "",
                end_time: "",
                start_datetime_utc: "",
                end_datetime_utc: "" 
            });
        }

        async function removeEventDate (location, index) {

            if(location.expos_dates.length <= 1) {
                return false;
            }
            location.expos_dates.splice(index, 1);
        }

        async function selectAll() {
            vm.expo.profile_types = vm.profileTypes.map(profile => profile.id);
        }

        async function removeAll() {
            vm.expo.profile_types = [];
        }

        async function selectTerritories() {
            const response = await CountriesNewService.getTerritories();
            vm.territories = response.data;
        }

        async function selectCountries() {
            const response = await CountriesNewService.getCountries();
            vm.countries = response.data;
            vm.exhibitorsCountries = angular.copy(vm.countries);
            vm.exhibitorsCountries.unshift({ id: '', iso: '', name: 'Worldwide' });
        }

        function getCountries() {
            vm.countries = []; 
            let promises = [];

            $.each(vm.selectedTerritories, function (key, territory_id) {
                let promise = CountriesNewService.getCountriesByTerritoryId(territory_id).then(function (response) {
                    return response.data; 
                });
                promises.push(promise);
            });

            Promise.all(promises).then(function (results) {
                vm.countries = [].concat(...results);

                vm.countries.sort(function (a, b) {
                    return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
                });                
            });
        }

        async function activate() { 
            vm.expoTypes = expoTypes;
            vm.aliases = aliases;
            vm.serviceRegions = serviceRegions;
            vm.costCenters = costCenters;
            vm.currencies = currencies;
            vm.eventGroups = eventGroups;
            vm.profileTypes = profileTypes;
            vm.cities = cities;

            await vm.selectTerritories();
            await vm.selectCountries();
            await vm.getTitle();
            await vm.mountExpo();

            // Parse colors
            vm.eventsColors.forEach(function(item) {
                item.colors = JSON.parse(item.colors);
            });
        }

        activate();

        function setExhibitorsCountry() {
            vm.expo.target_exhibitors = vm.expo.exhibitors_country.name;
        }
        
    }
})();
